import React from 'react';
import './App.css';
import Esri3DMap from './esri3Dmap';

function App() {
  return (
    <div className="App">
      <Esri3DMap />
    </div>
  );
}

export default App;
